import React from 'react';
import { Modal, Form } from 'react-bootstrap';

function EventView({ tip, handleClose, handleShow, show }) {


    React.useEffect(() => {
        if (tip) {
            handleShow();
        }
    }, [tip, handleShow]);

    return (
        <>


            {/* Modal to display tip details */}
            <Modal show={show} className="custom-modal" size="lg" centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Tip</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12">
                            <Form.Label className="mb-0">Title</Form.Label>
                            <p>{tip?.title}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className="mb-0">Date</Form.Label>
                            <p>{tip?.date && new Date(tip.date).toLocaleDateString()}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className="mb-0">Content</Form.Label>
                            <p dangerouslySetInnerHTML={{ __html: tip?.content }}></p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default EventView;
